<template>
    <div class="container">
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-label">
                    <h3>Selected shops: {{selectedShops.length}}</h3>
                </div>
            </div>
            <div class="panel-body">
                <div class="shops">
                    <div class="shop-items mb-2" v-for="shop in selectedShops" :key="shop.id">
                        <img :src="shop.iconURL" width="20" class="mr-1"/> 
                        <span> {{shop.name}} </span>
                    </div>
                </div>
            </div>
        </div>
        <ProductsBulkTable :fastedit="'fastedit'" :apply-to-shops="selectedShops" id="default-config"></ProductsBulkTable>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import ProductsBulkTable from '../Products/ProductsBulkTable';
    export default {
        name: 'ProductsBulk',
        components: {
            ProductsBulkTable
        },
        data() {
            return {

            }
        },
        computed: {
            ...mapGetters({
                selectedShops: 'getSelectedShops'
            })
        },
        methods: {
            ...mapActions([
                'getContextNotifications'
            ]),
            onSearch(data) {
                this.AddProductsTableFilters(data);
            },
        }
    }
</script>

<style lang="scss">

</style>
